"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var aws_api_gateway_client_1 = require("aws-api-gateway-client");
var lodash_1 = require("lodash");
var promiseMemoize = require("promise-memoize");
var isBrowser = typeof window !== 'undefined';
var headers = isBrowser
    ? {}
    : {
        'Accept-Encoding': 'gzip, deflate, br',
    };
var Endpoint = (function () {
    function Endpoint(stage, mapping) {
        this.stage = stage;
        this.createClient(mapping);
    }
    Endpoint.prototype.changeMapping = function (mapping) {
        this.createClient(mapping);
    };
    Endpoint.prototype.invokePOST = function (params, path, body) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, invokePOST(this.client, params, path, body)];
            });
        });
    };
    Endpoint.prototype.invokePUT = function (params, path, body) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, invokePUT(this.client, params, path, body)];
            });
        });
    };
    Endpoint.prototype.invoke = function (method, params, path, query) {
        return __awaiter(this, void 0, void 0, function () {
            var response, _a, statusCode, body;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, this.client.invokeApi(params, path, method, {
                            headers: headers,
                            queryParams: query,
                        }, {})];
                    case 1:
                        response = _b.sent();
                        _a = response.data, statusCode = _a.statusCode, body = _a.body;
                        if (!statusCode || !body) {
                            return [2, response.data];
                        }
                        else if (statusCode === 200) {
                            return [2, JSON.parse(body)];
                        }
                        else {
                            if (response.data.isError) {
                                throw Error(response.data.message);
                            }
                            else {
                                throw response.data;
                            }
                        }
                        return [2];
                }
            });
        });
    };
    Endpoint.prototype.invokeDELETE = function (params, path, query) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, invokeDELETE(this.client, params, path, query)];
            });
        });
    };
    Endpoint.prototype.invokeShortGET = function (params, path, query) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, GET_SHORT(this.client, params, path, query)];
            });
        });
    };
    Endpoint.prototype.invokeNoCacheGET = function (params, path, query) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, invokeGET(this.client, params, path, query)];
            });
        });
    };
    Endpoint.prototype.invokePermanentGET = function (params, path, query) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, GET_PERMANENT(this.client, params, path, query)];
            });
        });
    };
    Endpoint.prototype.createClient = function (mapping) {
        var invokeUrl = mapping[this.stage].endpoint;
        var opts = {
            apiKey: mapping[this.stage].apiKey,
            invokeUrl: invokeUrl,
            region: 'eu-central-1',
        };
        if (!opts.apiKey) {
            delete opts.apiKey;
        }
        this.client = aws_api_gateway_client_1.default.newClient(opts);
    };
    return Endpoint;
}());
exports.Endpoint = Endpoint;
function invokeGET(client, params, path, query) {
    return __awaiter(this, void 0, void 0, function () {
        var sanitizedQuery, response, _a, statusCode, body;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    sanitizedQuery = lodash_1.omitBy(query, lodash_1.isNil);
                    return [4, client.invokeApi(params, path, 'GET', {
                            headers: headers,
                            queryParams: sanitizedQuery,
                        }, {})];
                case 1:
                    response = _b.sent();
                    _a = response.data, statusCode = _a.statusCode, body = _a.body;
                    if (!statusCode || !body) {
                        return [2, response.data];
                    }
                    else if (statusCode === 200) {
                        return [2, JSON.parse(body)];
                    }
                    else {
                        throw new Error("statusCode: " + statusCode);
                    }
                    return [2];
            }
        });
    });
}
function invokeDELETE(client, params, path, query) {
    return __awaiter(this, void 0, void 0, function () {
        var sanitizedQuery, response, _a, statusCode, body;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    sanitizedQuery = lodash_1.omitBy(query, lodash_1.isNil);
                    return [4, client.invokeApi(params, path, 'DELETE', {
                            headers: headers,
                            queryParams: sanitizedQuery,
                        }, {})];
                case 1:
                    response = _b.sent();
                    _a = response.data, statusCode = _a.statusCode, body = _a.body;
                    if (!statusCode || !body) {
                        return [2, response.data];
                    }
                    else if (statusCode === 200) {
                        return [2, JSON.parse(body)];
                    }
                    else {
                        throw new Error("statusCode: " + statusCode);
                    }
                    return [2];
            }
        });
    });
}
function invokePOST(client, params, path, body) {
    return __awaiter(this, void 0, void 0, function () {
        var response, _a, statusCode, responseBody;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, client.invokeApi(params, path, 'POST', {
                        headers: headers,
                    }, body)];
                case 1:
                    response = _b.sent();
                    _a = response.data, statusCode = _a.statusCode, responseBody = _a.responseBody;
                    if (!statusCode || !responseBody) {
                        return [2, response.data];
                    }
                    else if (statusCode === 200) {
                        return [2, JSON.parse(responseBody)];
                    }
                    else {
                        throw new Error("statusCode: " + statusCode);
                    }
                    return [2];
            }
        });
    });
}
function invokePUT(client, params, path, body) {
    return __awaiter(this, void 0, void 0, function () {
        var response, _a, statusCode, responseBody;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, client.invokeApi(params, path, 'PUT', {
                        headers: headers,
                    }, body)];
                case 1:
                    response = _b.sent();
                    _a = response.data, statusCode = _a.statusCode, responseBody = _a.responseBody;
                    if (!statusCode || !responseBody) {
                        return [2, response.data];
                    }
                    else if (statusCode === 200) {
                        return [2, JSON.parse(responseBody)];
                    }
                    else {
                        throw new Error("statusCode: " + statusCode);
                    }
                    return [2];
            }
        });
    });
}
var GET_PERMANENT = promiseMemoize(invokeGET, {
    maxAge: 12 * 60 * 60 * 1000,
    resolve: 'json',
});
var GET_SHORT = promiseMemoize(invokeGET, {
    maxAge: 60 * 1000,
    resolve: 'json',
});
//# sourceMappingURL=endpoint.js.map